export default __webpack_public_path__ + "static/media/retainoo.48793f38.png";